import * as angular from 'angular';
import { ILoggerService } from './logger.service';

export interface ITranslatedLoggerService extends ILoggerService {
}

export class TranslatedLoggerService implements ITranslatedLoggerService {
    static serviceId = 'translatedLoggerService';

    static $inject = ['$translate', 'loggerService'];

    constructor(
        private _$translate: angular.translate.ITranslateService,
        private _loggerService: ILoggerService
    ) {
    }

    log(message: string, showToast?: boolean, data?: Object, source?: string, sendNotification?: boolean): void {
        this.translate(message, data)
            .then(r => this._loggerService.log(r, showToast, data, source, sendNotification));
    }

    logSuccess(message: string, showToast?: boolean, data?: Object, source?: string, sendNotification?: boolean): void {
        this.translate(message, data)
            .then(r => this._loggerService.logSuccess(r, showToast, data, source, sendNotification));
    }

    logWarning(message: string, showToast?: boolean, data?: Object, source?: string, sendNotification?: boolean): void {
        this.translate(message, data)
            .then(r => this._loggerService.logWarning(r, showToast, data, source, sendNotification));
    }

    logError(message: string, showToast?: boolean, data?: Object, source?: string, sendNotification?: boolean): void {
        this.translate(message, data)
            .then(r => this._loggerService.logError(r, showToast, data, source, sendNotification));
    }


    private translate(message: string, data?: Object): angular.IPromise<string> {
        return this._$translate(message, data)
            .then(r => r ?? message)
            .catch(() => message);
    }
}